// |-- Built-in Dependencies --|
import React, { useState, useEffect } from "react";

// |-- External Dependencies --|
import { Form, Formik } from "formik";
import { object, string } from "yup";
import Dialog from "@mui/material/Dialog";
import CircularProgress from "@mui/material/CircularProgress";

// |-- Internal Dependencies --|
import { showToast } from "src/utils/showToaster";
import DispositionLevelOneForm from "../Layout/DispositionLevelOneForm";
import {
  useGetDispositionLevelOneByIdQuery,
  useEditDispositionLevelOneMutation,
} from "src/services/DispositionLevelOneServices";

// |-- Types --|
type Props = {
  dispositionLevelFirstId: string;
  onClose: () => void;
};

export type FormInitialValues = {
  dispositionFirstName: string;
};
const EditDispositionLevelOneFormWrapper = ({
  dispositionLevelFirstId,
  onClose,
}: Props) => {
  const [dispositionLevelFirstData, setDispositionLevelFirstData] =
    useState<any>([]);

  const { data, isLoading, isFetching } = useGetDispositionLevelOneByIdQuery(
    dispositionLevelFirstId,
    {
      skip: !dispositionLevelFirstId,
    }
  );

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setDispositionLevelFirstData(data?.data);
    }
  }, [isLoading, isFetching, data]);

  const [editDispositionLevelOne] = useEditDispositionLevelOneMutation();

  const initialValues: FormInitialValues = {
    dispositionFirstName: dispositionLevelFirstData?.dispositionFirstName,
  };

  const validationSchema = object({
    dispositionFirstName: string().required(
      "Disposition first name is required"
    ),
  });

  const onSubmitHandler = (values: FormInitialValues) => {
    setTimeout(() => {
      editDispositionLevelOne({ id: dispositionLevelFirstId, body: values })
        .then((res: any) => {
          if (res?.data?.status) {
            showToast("success", "added successfully!");
            onClose();
          } else {
            showToast("error", res?.data?.message);
            onClose();
          }
        })
        .catch((err) => {
          console.error("error", err);
        });
    }, 1000);
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmitHandler}
      >
        {(formikProps) => {
          return (
            <Form>
              {(isLoading || isFetching) && (
                <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                  <CircularProgress />
                </div>
              )}
              <DispositionLevelOneForm
                formType="Edit"
                onClose={onClose}
                formikProps={formikProps}
              />
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

export default EditDispositionLevelOneFormWrapper;
